const getStyles = (status) => {
  switch (status) {
    case 'Not Started':
      return { color: '#161C24', backgroundColor: '#DFE3E8' };
    case 'In Progress':
      return { color: '#d49116', backgroundColor: '#fff3bb' };
    case 'Completed':
      return { color: '#188d1a', backgroundColor: '#b3ffb3' };
    case 'Blocked':
      return { color: 'red', backgroundColor: 'lightpink' };
    case 'Reopened':
      return { color: '#0C53B7', backgroundColor: '#D0F2FF' };
    default:
      return { color: 'inherit', backgroundColor: 'inherit' };
  }
};

export default getStyles;
